$(document).ready(function () {
  // https://benfrain.com/automatically-play-and-pause-video-as-it-enters-and-leaves-the-viewport-screen/
  function playPauseVideo() {
    let videos = document.querySelectorAll("video");

    //showInfo
    videos.forEach((video) => {

     // let info = video.parentElement.parentNode.nextElementSibling;
      // We can only control playback without insteraction if video is mute
      video.muted = true;
      // Play is a promise so we need to check we have it
      let playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {
          let observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (
                  entry.intersectionRatio !== 1 &&
                  !video.paused
                ) {
                  video.pause();
                } else if (video.paused) {
                  video.play();
                }
              });
            },
            { threshold: 0.8 }
          );
          observer.observe(video);
        });
      }
    });
  }

  // And you would kick this off where appropriate with:
  playPauseVideo();


/*  var controller = new ScrollMagic.Controller();

  var showInfoService = document.getElementsByClassName("info-side");

  for (var j=0; j<showInfoService.length; j++) { // create a scene for each element
    new ScrollMagic.Scene({
      triggerElement: showInfoService[j], // y value not modified, so we can use element as trigger as well
     // offset: -50,												 // start a little later
      triggerHook: 0.9,
    })
      .setClassToggle(showInfoService[j], "showInfo") // add class toggle
      .addIndicators({name: "digit " + (j+1) }) // add indicators (requires plugin)
      .addTo(controller);
  }*/

});
